import { sendWebsocketMessage } from '../../../../../../App';

export function pauseAllTradePlans(){
  const msg = {
    messageType: 'pauseAllTradePlans'
  };

  sendWebsocketMessage(msg);
}
